module.exports = __webpack_public_path__ + "img/a2d-retro-logo-frame.e5bf6e9a.png";